// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"86c46ff2","455":"6f6fd6ef"}[chunkId] + ".chunk.js";
};